import editorCapabilities, { AI_SUMMARY, BLOCKQUOTE, BOLD, CLEAR_FORMATTING, FILE_ATTACHMENTS, FONT_SIZE, FONT_STYLE, INLINE_IMAGE, ITALIC, LINK, LISTS, RENDER_SUBMIT_BUTTON, RENDER_TRAY, STRIKETHROUGH, TEXT_ALIGN, TEXT_COLOR, TEXT_HIGHLIGHT, UNDERLINE, DRAFT_NOT_SAVED, MACROS, FORMATTING_TRAY } from '../../editorCapabilities';
import { LAYOUT_TYPES } from '../../editorCapabilities/toolbarCustomization';
import { INSERT_CAPABILITIES } from '../partials/InsertMenuCapabilities';
import CssVariablesTheme from 'foundations-theming/css-vars-theme';
import { TextColorIcon } from 'foundations-assets';

/**
 * @description The toolbar layout for the inbox.
 */

// Gets the hex value of the css variable since there's no easy way to prop drill the theme
import { jsx as _jsx } from "react/jsx-runtime";
const borderCoreDefault = window.getComputedStyle(document.documentElement).getPropertyValue(CssVariablesTheme.color['border-core-default']);
export const inboxLayout = [{
  key: 'inbox-text-formatting',
  layoutType: LAYOUT_TYPES.DROPDOWN,
  buttonText: /*#__PURE__*/_jsx(TextColorIcon, {
    color: "fill-accent-neutral-default"
  }),
  caretRenderer: () => null,
  children: [BOLD, ITALIC, UNDERLINE, CLEAR_FORMATTING, FONT_STYLE, FONT_SIZE, TEXT_COLOR, TEXT_HIGHLIGHT, STRIKETHROUGH, BLOCKQUOTE, LISTS, TEXT_ALIGN, DRAFT_NOT_SAVED]
}, editorCapabilities.EMOJI, LINK, {
  layoutType: LAYOUT_TYPES.DIVIDER,
  key: 'inbox-layout-divider',
  style: {
    width: 1,
    backgroundColor: borderCoreDefault,
    border: 'none'
  }
}, INLINE_IMAGE, FILE_ATTACHMENTS, editorCapabilities.CONTENT_ASSISTANT, AI_SUMMARY, editorCapabilities.AI_ASSISTANT, {
  key: 'prosemirror-insert-menu',
  layoutType: LAYOUT_TYPES.INSERT_MENU,
  children: INSERT_CAPABILITIES
}, DRAFT_NOT_SAVED, {
  layoutType: LAYOUT_TYPES.SPACER,
  key: 'spacer-key-1'
}, RENDER_TRAY, MACROS, RENDER_SUBMIT_BUTTON];

/**
 * @description The toolbar layout for the inbox with the formatting tray toggle.
 * Replaces the first element of the inbox layout with the formatting tray toggle button.
 */
export const inboxLayoutWithFormattingTrayToggle = [FORMATTING_TRAY, ...inboxLayout.slice(1)];

/**
 * @description The formatting tray layout for the inbox.
 */
export const inboxFormattingTrayLayout = [BOLD, ITALIC, UNDERLINE, CLEAR_FORMATTING, FONT_STYLE, FONT_SIZE, TEXT_COLOR, TEXT_HIGHLIGHT, STRIKETHROUGH, BLOCKQUOTE, LISTS, TEXT_ALIGN, DRAFT_NOT_SAVED];